import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-alert-message',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './alert-message.component.html',
  styleUrl: './alert-message.component.scss'
})
export class AlertMessageComponent {
  @Input() type: string;
  @Input() mt: string;
  @Input() mb: string;
  @Input() canClose = false;
  @Output() onClose = new EventEmitter;

  onClickClose() {
    this.onClose.emit();
  }
}
